var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconOrderedList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01058 4.06242H17.9168M9.01058 9.99992H17.9168M10.0002 15.9374H17.9168M4.06266 8.02075V2.08325L2.0835 4.06242",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13439 17.1666C4.44262 17.1666 4.70375 17.1366 4.9178 17.0767C5.14041 17.0082 5.30309 16.944 5.40583 16.884V15.2273L3.98028 15.3686C3.58643 15.4028 3.28676 15.4927 3.08128 15.6383C2.88436 15.7753 2.78589 15.9808 2.78589 16.2547C2.78589 16.5373 2.8972 16.7599 3.11981 16.9226C3.34242 17.0852 3.68061 17.1666 4.13439 17.1666ZM4.09586 11.824C4.89212 11.824 5.52141 11.9995 5.98375 12.3505C6.45466 12.693 6.69011 13.2367 6.69011 13.9816V16.9739C6.69011 17.1709 6.6473 17.325 6.56168 17.4363C6.47606 17.5476 6.3562 17.6461 6.20208 17.7317C5.97947 17.8601 5.68837 17.9671 5.32877 18.0527C4.97773 18.1469 4.57961 18.194 4.13439 18.194C3.30389 18.194 2.65318 18.0356 2.18228 17.7188C1.71994 17.3935 1.48877 16.9183 1.48877 16.2933C1.48877 15.7282 1.67285 15.2958 2.04101 14.9962C2.40917 14.6879 2.93145 14.5038 3.60783 14.4439L5.40583 14.2641V13.9687C5.40583 13.5834 5.28168 13.3052 5.03339 13.1339C4.78509 12.9627 4.4469 12.8771 4.0188 12.8771C3.67633 12.8771 3.34242 12.9242 3.01706 13.0184C2.70027 13.1125 2.41773 13.2196 2.16944 13.3394C2.09238 13.2709 2.02389 13.1896 1.96395 13.0954C1.90402 12.9927 1.87405 12.8856 1.87405 12.7743C1.87405 12.5089 2.01961 12.3077 2.31071 12.1707C2.55044 12.0594 2.82442 11.9738 3.13265 11.9139C3.44944 11.8539 3.77051 11.824 4.09586 11.824Z",
    fill: "#7A7A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconOrderedList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-ordered-list.94da1c077540c39f5ceed7489a0286e7.svg";